import React from 'react';
import { connect } from 'react-redux'
// GameGuide imports
import GuideStepContainer from '../layout';
import StepTitleExit from '../stepTitleExit';
import { nextStep } from '../../../actions/gameGuideActions';
import Sign from '../sign';
import settings from '../../../../settings';

const StartSignDefaultProps = {
    content: <></>,
    description: "",
    onClick: () => {},
    locked: false
};

class GuideStepStart extends React.Component {
    onStart = () => {
        const { dispatch } = this.props;
        dispatch(nextStep());
    }

    StartSign = (props = StartSignDefaultProps) => {
        const {number, content, description, onClick, locked } = props;

        return (
            <div className="start-sign-wrapper">
                <Sign
                    content={(<>
                        stap
                        <span>{number}</span>
                    </>)}
                    onClick={onClick}
                    locked={locked}
                    className={locked ? "locked" : ""}
                />
                {content}
                <p>{description}</p>
            </div>
        );
    }

    Signs = () => {
        return (
            <div className="signs-container">
                <this.StartSign
                    number={1}
                    onClick={this.onStart}
                    description="Maak je speler"
                    locked={false}
                    content={<></>}
                />
                <this.StartSign
                    number={2}
                    locked
                    description="Speldoel &amp; Score"
                    content={<></>}
                />
                <this.StartSign
                    number={3}
                    locked
                    description="Levels bouwen"
                    content={<></>}
                />
                
                <this.StartSign
                    number={4}
                    locked
                    description="Publiceren"
                />
            </div>
        );
    }

    Button = () => {
        const { user } = this.props;

        const button = (
            <button 
                onClick={this.onStart}
                type="button"
            >
                start!
            </button>
        );

        let content = <></>;
        let containerClassName = "has-margin";
        if(!user.loggedIn) {
            content = (
                <>
                    <img className="text-balloon" src={`${settings.assetsPath}img/text-balloons/nog-inloggen-groen.png`} alt="Nog inloggen!" onClick={this.onStart} />
                    <div className="bottom-row">
                        <img className="disc" src={`${settings.assetsPath}img/icons/disc.png`} alt="Disk blij"/>
                        {button}
                    </div>
                </>
            );
            containerClassName = "";
        } else {
            content = button;
        }

        return (
            <div className={`btn-start ${containerClassName}`}>
                {content}
            </div>
        );
    }

    render() {
        const { id } = this.props;
        
        return (
            <GuideStepContainer 
                titleElement={
                    <StepTitleExit
                        content="Zo maak je een game"
                    />
                } 
                id={id}
            >
                <this.Signs />
                <this.Button />
            </GuideStepContainer>
        );
    }
}

GuideStepStart.defaultProps = { };

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    gameGuide: state.gameGuide,
    user: state.user
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GuideStepStart);